import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { makeGetDetailInformation } from '../../redux/product/selectors/ProductSelector';
import { ProductDetailInformationHead } from '../../components/product-detail/product-detail-information-head/ProductDetailInformationHead';
export const ProductDetailInformationContainer = () => {
    const detailInformation = useSelector(makeGetDetailInformation());
    const { brand, description, title } = detailInformation;
    return _jsx(ProductDetailInformationHead, { brand: brand, description: description, title: title });
};
